// @flow
import types from "./types";
import type {Action} from "../DucksUtils";
import type {LatLngType} from "../../../Utils/AppUtils";

type MandatoryKeys = {|
    token: string,
    rider_details: Object,
    first_name: string,
    rider_id: string,
    phone_number: string,
|}

type OptionalKeys = {|
    origin_lat?: number,
    origin_lng?: number,
    origin_type?: LatLngType,
    dest_lat?: number,
    dest_lng?: number,
    dest_type?: LatLngType,
    corporate_id?: number,
    city_id?: number,
    error?: string,
    passenger_count?: number,
|}

export type TokenData = { ...OptionalKeys, ...MandatoryKeys } | OptionalKeys;

export const TokenDataDefault = Object.freeze({});

const TokenDataReducer = (tokenData: TokenData = TokenDataDefault, action: Action): TokenData => {
    const type: string = action.type;
    const payload = action.payload;
    switch (type) {
        case types.TOKEN_DATA_UPDATE:
            return {
                ...payload,
                error: undefined,
            };
        case types.TOKEN_DATA_ERROR:
            return {
                error: payload,
            };
        default:
            return tokenData;
    }
};

export default TokenDataReducer;





// WEBPACK FOOTER //
// ./src/Store/Ducks/TokenData/reducers.js